import type { HttpClientConfig } from 'core/infra/http/HttpClient'

import {
  type AuthenticationOptions,
  type AgnosticStrongAuthRepository,
} from '../infra/AgnosticStrongAuthRepository'
import { createAgnosticStrongAuthRepository } from '../infra/createAgnosticStrongAuthRepository'

export type FetchJwtTokenRepositoryParams = {
  repository: AgnosticStrongAuthRepository
}

export async function authenticateAgnosticUser(
  params: AuthenticationOptions,
  config?: Partial<HttpClientConfig>
): Promise<string> {
  const repository = createAgnosticStrongAuthRepository()

  const token = await repository.fetchAccessToken(params, config)

  repository.setLocalToken(token)

  return token
}
